import "./MaterialCatalog.module.css";
import Navigation from "@/reusable_sections/Header";
import Portfolio from "./sections/Portfolio";
import Hardware from "./sections/Hardware";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function MaterialCatalogPage() {
  return <div>
      <Navigation />
      <Portfolio />
      <Hardware />
      <Quote />
      <Footer />
    </div>;
}